var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageLoader'),_c('v-app',{attrs:{"id":"app"}},[_c('span',{staticStyle:{"min-height":"100vh"}},[_c('router-view',{attrs:{"storage":_vm.sideNav}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }